import { Utils } from "./utils";
/**
 * 表单验证
 */
const regular = {
  phone: /^1[3456789]\d{9}$/,
  testCode: /^[0-9]+$/,
  password: /^[A-Za-z0-9_-]{6,12}$/,
  name: /(^[\u4e00-\u9fa5a-zA-Z]{1,}\s*[\u4e00-\u9fa5a-zA-Z]{1,}$)|(^[\u4e00-\u9fa5a-zA-Z]{1,}$)/,
  manageName: /(^[\u4e00-\u9fa5a-zA-Z0-9_]{1,}\s*[\u4e00-\u9fa5a-zA-Z0-9_]{1,}$)|(^[\u4e00-\u9fa5a-zA-Z0-9_]{1,}$)/,
};
const tiptext = {
  name: {
    empty: "请输入姓名",
    format: "姓名由字母、汉字及空格组成(不能以空格开头或结尾)",
  },
  manageName: {
    empty: "请输入用户名",
    format: "姓名由字母、汉字、数字及空格组成(不能以空格开头或结尾)",
  },
  phone: {
    empty: "请输入手机号",
    format: "手机号码有误，请重新输入",
    len: "手机号码的长度为11位",
  },
  password: {
    empty: "请输入密码",
    format: "该号码格式错误",
  },
  testCode: {
    empty: "请输入验证码",
    format: "验证码有误，请重新输入",
  },
  date: {
    empty: "请选择到场日期",
  },
  time: {
    empty: "请选择到场时间段",
  },
};
const utils = {
  scrollResolve: function() {
    const arr = navigator.userAgent
      .toLowerCase()
      .match(/cpu iphone os (.*?) like mac os/);
    var iosV = 0;
    if (arr && arr.length) {
      iosV = parseInt(arr[1].replace(/_/g, "."));
    }
    if (iosV < 12) return;
    let currentPosition;
    let speed = 1;
    setTimeout(function() {
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed;
      window.scrollTo(0, currentPosition); //页面向下滚动
    }, 100);
  },
  split: function(obj) {
    //拆分验证的方法
    const { methods } = obj.dataset;
    const methodArr = [];
    methods.split("|").forEach((val) => {
      methodArr.push(val);
    });

    if (obj.dataset.len) {
      methodArr.push("len");
    }
    return methodArr;
  },

  isNull: function(value) {
    //验证是否为空
    if (
      value == null ||
      value == "" ||
      value.replace(/(^\s*)|(\s*$)/g, "") === ""
    ) {
      return true;
    }
    return false;
  },
  isNull1: function(value) {
    //只输入空字符时校验 返回true
    if (value.replace(/(^\s*)|(\s*$)/g, "") === "" && /\s/.test(value))
      return true;
    return false;
  },
  addStyle: function(option) {
    //验证失败的样式
    Validate.prototype.succs = false;
    option.label.innerText = option.msg;
    option.label.style.display = "block";
    option._this.style.borderColor = "#D00000";

    const labels = document.querySelectorAll("label");
    Array.from(labels).forEach((item) => {
      if (!item.innerHTML) {
        labels.style.display = "none";
      }
    });
    if (option.tagName === "SELECT") {
      option._this.style.color = "#999";
    }
  },
};
const methods = {
  notNull: (option) => {
    if (utils.isNull(option.value)) {
      option.msg = tiptext[option.type].empty;
      utils.addStyle(option);
    }
    return option;
  },
  name: (option) => {
    //验证名字格式
    if (!utils.isNull(option.value) && !regular.name.test(option.value)) {
      option.msg = tiptext[option.type].format;
      utils.addStyle(option);
    }
    return option;
  },
  manageName: (option) => {
    if (!utils.isNull(option.value) && !regular.manageName.test(option.value)) {
      option.msg = tiptext[option.type].format;
      utils.addStyle(option);
    }
    return option;
  },
  phone: (option) => {
    //验证手机号格式
    if (!utils.isNull(option.value) && !regular.phone.test(option.value)) {
      option.msg = tiptext[option.type].format;
      utils.addStyle(option);
    }
    return option;
  },
  password: (option) => {
    if (!utils.isNull(option.value) && !regular.password.test(option.value)) {
      option.msg = tiptext[option.type].format;
      utils.addStyle(option);
    }
    return option;
  },
  testCode: (option) => {
    //验证验证码格式
    if (
      (!utils.isNull(option.value) && !regular.testCode.test(option.value)) ||
      option.value.length !== 4
    ) {
      option.msg = tiptext[option.type].format;
      utils.addStyle(option);
    }
    return option;
  },
  len: function(option) {
    if (option._this.dataset.len < option.value.length) {
      option.msg = tiptext[option.type].len;
      utils.addStyle(option);
    }
    return option;
  },
  date: (option) => {
    //验证验证码格式
    if (!utils.isNull(option.value)) {
      option.msg = tiptext[option.type].format;
      utils.addStyle(option);
    }
    return option;
  },
  time: (option) => {
    //验证验证码格式
    if (!utils.isNull(option.value)) {
      option.msg = tiptext[option.type].format;
      utils.addStyle(option);
    }
    return option;
  },
};

class Validate {
  constructor(params) {
    this.elem = params;
  }

  getInputElem() {
    let inputs = null;
    if (this.elem.tagName === "FORM") {
      inputs = this.elem.querySelectorAll("[data-validate=true]");
    }
    if (this.elem.tagName === "INPUT" || this.elem.tagName === "SELECT")
      inputs = [this.elem];
    return inputs;
  }

  init() {
    // 0 验证整个表单   1  验证某个input
    Validate.prototype.succs = true;
    let inputs = this.getInputElem();
    Array.from(inputs).forEach((item) => {
      /**
       * 获取当前对象的信息
       */
      let option = { flag: false };
      option.type = item.dataset.type;
      option.tagName = item.tagName;
      option.value = item.value;
      option._this = item;
      option.label = item.parentElement.nextElementSibling;
      option.parent = item.parentElement;

      /**
       * 开始验证表单
       */
      const medArr = utils.split(item);

      medArr.forEach((val) => {
        option = methods[val](option);
      });
    });
    return Validate.prototype.succs;
  }

  valid() {
    //验证规则
    let inputs = this.getInputElem();
    Array.from(inputs).forEach((item) => {
      /**
       * 获取当前对象的信息
       */
      let option = {};
      // option.type = item.dataset.type
      // option.tagName = item.tagName
      // option.value = item.value
      // option._this = item
      option.preLabel = item.parentElement.previousElementSibling;
      option.label = item.parentElement.nextElementSibling;
      option.parent = item.parentElement;
      option.self = item;
      option.placeholder = item.dataset.placeholder;

      item.addEventListener(
        "focus",
        (e) => {
          console.log("focus");
          const target = e.target;
          option.preLabel.style.opacity = 1;
          item.placeholder = "";
          // 聚焦清除上次的校验信息
          target.parentElement.nextElementSibling.innerText = "";
          // 聚焦隐藏上次校验信息
          target.parentElement.nextElementSibling.style.display = "none";
          // 聚焦光标定位到末尾
          let len = target.value.length;
          Utils.setSelectionRange(target, len, len);
        },
        false
      );

      /**
       * 输入时隐藏错误提示
       */
      item.addEventListener(
        "input",
        (e) => {
          if (!utils.isNull(e.target.value)) {
            option.label.innerText = "";
            option.label.style.display = "none";
            option.self.style.borderColor = "#000";
          }
        },
        false
      );
      /**
       * 失去焦点时验证
       */

      item.addEventListener(
        "blur",
        (e) => {
          utils.scrollResolve();
          const target = e.target;

          // 设置边框颜色
          if (!target.parentElement.nextElementSibling.innerText) {
            target.style.borderColor = "#eaeaea";
          } else if (
            target.parentElement.nextElementSibling.innerText &&
            utils.isNull1(target.value)
          ) {
            target.style.borderColor = "#D00000";
          }

          if (
            utils.isNull1(target.value) ||
            target.value.replace(/(^\s*)|(\s*$)/g, "")
          ) {
            //开始验证表单
            const valid = new Validate(target);
            valid.init();
          }

          if (target.value == "") {
            option.preLabel.style.opacity = 0;
            item.placeholder = option.placeholder;
          }
        },
        false
      );
      item.addEventListener("change", (e) => {
        const target = e.target;
        if (target.tagName === "SELECT") {
          // select被选中时字体颜色控制
          if (target.value) {
            target.style.color = "#000";
          } else {
            target.style.color = "#999";
          }
        }
      });
    });
  }
}
// 判断整个表单验证是否通过
Validate.prototype.succs = true;
export default Validate;
